var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("number number--color-" + _vm.color)},[_c('div',{staticClass:"number__value"},[_vm._t("value")],2),_c('div',{staticClass:"number__label"},[_vm._t("label")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }